import { Button } from "../../components/Button";
import { Col, Container, Row } from "react-grid-system";
import { Outlet, useParams } from "react-router-dom";
import { Search } from "../../components/Search";
import { Sidemenu } from "../../components/Sidemenu";
import { StyledPageHeader } from "../../styles/StyledPage";
import { UnitTree } from "../../components/UnitList/UnitTree";
import { useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";

export default function UnitsPage() {
	const [phrase, setPhrase] = useState(false);
	const [myUnits, setMyUnits] = useState(false);
	const params = useParams();
	const { isOrgAdmin } = useCurrentUser();

	return (
		<>
			{!params.id && (
				<Container>
					<Row style={{ marginTop: "2rem" }}>
						<Col sm={12} lg={2}>
							<Sidemenu />
						</Col>
						<Col sm={12} lg={10}>
							<StyledPageHeader>
								<h1>Units</h1>
								<div>
									{/* Other users only see their own units anyway */}
									{isOrgAdmin && (
										<Button onClick={() => setMyUnits(!myUnits)} bg={false} small={true}>
											{myUnits ? "Show all units" : "Show only my units"}
										</Button>
									)}
									<Search isWhite setPhrase={setPhrase} />
								</div>
							</StyledPageHeader>
							<UnitTree phrase={phrase} myUnits={myUnits} />
						</Col>
					</Row>
				</Container>
			)}
			<Outlet />
		</>
	);
}
